import { jsx } from "@emotion/react/jsx-runtime";
import DevNotice from "./DevNotice.mjs";
import useThemeProps from "./useThemeProps.mjs";
function Image(props) {
  props = useThemeProps({
    props,
    name: "Image"
  });
  let {
    handler: Component = props2 => /* @__PURE__ */jsx(DevNotice, {
      ...props2,
      children: "No image handler specified"
    }),
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(Component, {
    ...restProps
  });
}
export { Image as default };